exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".coinsEarnedDisplay{text-align:right}.coinsEarnedDisplay p{font-size:.8em}.coinsEarnedDisplay p.excluded{padding-right:10px}.coinsEarnedDisplay a{padding-left:10px}.coinsEarnedDisplay .coinDetailsModal{text-align:left}.coinsEarnedDisplay .coinTable td:first-child{width:100px;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/shelves/coins_earned_display.scss
// module id = 1403
// module chunks = 0